import type { FunctionComponent } from 'react';

import {
  Button,
  Loader,
  type StringIndexedObject,
  Text,
} from '@kanda-libs/ks-design-library';

import useJobSatNoteProps from 'components/job/JobLayout/JobSatNote/useJobSatNoteProps';

export interface JobSatNoteProps { }

const JobSatNote: FunctionComponent<JobSatNoteProps> = function() {
  const {
    showContent,
    showApprove,
    onClick,
    onApproveClick,
    onDelayClick,
    onWithLenderClick,
    isSubmitting,
    timeline,
    fingerprint,
    questions,
    isLoading,
    showSendToLender,
  } = useJobSatNoteProps();

  if (!showContent) return <></>;

  return (
    <div className="flex flex-col mb-6">
      <Text
        text="Sat Note"
        className="mb-6 text-16-20-em text-neutral-800"
        isLoading={isLoading}
      />

      <div className="flex flex-col px-5 py-4 mb-2 border rounded-lg border-neutral-300 last:mb-0 shadow-card">
        <Text
          text="Timeline:"
          className="mb-2 text-14-22-em"
          isLoading={isLoading}
        />
        <div className="flex flex-row">
          <Text
            text="Job created:"
            className="text-14-22-em min-w-24"
            isLoading={isLoading}
          />
          <Text
            text={`${timeline?.created?.time} on ${timeline?.created?.date}`}
            className="ml-2 text-14-22"
            isLoading={isLoading}
          />
        </div>
        <Text
          text="Sat Note Timeline:"
          className="mt-4 mb-2 text-14-22-em"
          isLoading={isLoading}
        />
        <div className="flex flex-row">
          <Text
            text="Sent:"
            className="text-14-22-em min-w-24"
            isLoading={isLoading}
          />
          <Text
            text={`${timeline?.sent?.time} on ${timeline?.sent?.date}`}
            className="ml-2 text-14-22"
            isLoading={isLoading}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Viewed:"
            className="text-14-22-em min-w-24"
            isLoading={isLoading}
          />
          <Text
            text={`${timeline?.viewed?.time} on ${timeline?.viewed?.date}`}
            className="ml-2 text-14-22"
            isLoading={isLoading}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Signed:"
            className="text-14-22-em min-w-24"
            isLoading={isLoading}
          />
          <Text
            text={`${timeline?.signed?.time} on ${timeline?.signed?.date}`}
            className="ml-2 text-14-22"
            isLoading={isLoading}
          />
        </div>
        <div className="flex flex-row">
          <Text
            text="Fingerprint:"
            className="text-14-22-em min-w-24"
            isLoading={isLoading}
          />
          <Text
            text={fingerprint}
            className="ml-2 text-14-22"
            isLoading={isLoading}
          />
        </div>

        <Text
          text="Questions:"
          className="mt-4 mb-2 text-14-22-em"
          isLoading={isLoading}
        />
        {Object.keys(questions).map((key: string) => (
          <div key={key} className={
            "flex flex-row" + (key === "pressure" && questions[key] !== "no" ? " red" : "")
          }>
            <Text
              text={`${key[0].toUpperCase() + key.substring(1)}:`}
              className="text-14-22-em min-w-24"
              isLoading={isLoading}
            />
            <Text
              text={(questions as StringIndexedObject)[key]}
              className="ml-2 text-14-22"
              isLoading={isLoading}
            />
          </div>
        ))}

        <Button.Text
          id="staff-download-sat-note"
          label="Dowload Sat Note"
          onClick={onClick}
          size={40}
          disabled={isSubmitting}
          className="mt-6"
        />

        {showApprove && (
          <Button.Text
            id="approve-sat-note"
            label="Approve Sat Note"
            onClick={onApproveClick}
            size={40}
            disabled={isSubmitting}
            className="mt-4"
          />
        )}
        {showApprove && (
          <Button.Text
            id="delay-sat-note"
            label="Delay Sat Note"
            onClick={onDelayClick}
            size={40}
            disabled={isSubmitting}
            className="mt-4"
          />
        )}
        {showApprove && showSendToLender && (
          <Button.Text
            id="lender-sat-note"
            label="Send Sat Note To Lender"
            onClick={onWithLenderClick}
            size={40}
            disabled={isSubmitting}
            className="mt-4"
          />
        )}

        <Loader isLoading={isSubmitting} />
      </div>
    </div>
  );
};

export default JobSatNote;
